import React from "react";
import { HelpCircle } from "lucide-react";
import { useTour } from "./TourProvider";

/* -----------------------------------------------------------------------------
 * TourLauncherButton — persistent "❓ Guía de Recarga" button. Callable from
 * anywhere in the client UI. Starts the tour from step 1 on click.
 * --------------------------------------------------------------------------- */
export function TourLauncherButton() {
  const tour = useTour();
  if (!tour) return null;
  return (
    <button
      onClick={tour.start}
      data-testid="tour-launcher-btn"
      title="Guía interactiva de recarga"
      aria-label="Iniciar guía interactiva de recarga"
      className="flex items-center gap-1.5 px-2.5 sm:px-3 py-1.5 rounded-xl text-[11px] sm:text-xs font-bold text-cyan-300 border border-cyan-500/40 bg-cyan-500/10 hover:bg-cyan-500/20 transition-all whitespace-nowrap"
    >
      <HelpCircle className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
      <span className="hidden sm:inline">Guía de Recarga</span>
      <span className="sm:hidden">Guía</span>
    </button>
  );
}
